import React, { Component } from "react";
import BMW from "../image/xiaomi.png";
import Call from "../icon/Call";
import Message from "../icon/Message";
import Telegram from "../icon/Telegram";
import Twtter from "../icon/Twtter";
import Facebook from "../icon/Facebook";
import "../style/fail.scss";
import Messenger from "../image/messenger.png";

import Close from "../icon/Close";
import Lihua from "../icon/Lihua";
import MobileDetectUtil from "../utils/MobileDetectUtil";

import sahua from "../image/sahua.gif";
import * as CountPixelEventAPI from "../apis/CountPixelEventAPI";
import { url } from "../constants/ApiEndpointConstants";

import HeadBar from "./common/HeadBar";
import share from "../image/share.png";

import { BASE_URL } from "../constants/ApiEndpointConstants";
import * as PostMessageAPI from "../apis/PostMessageAPI";
import { lang } from "../utils/lang";

const invitation_text = lang.shareText;
const HTTP_REQUEST_URL = BASE_URL + "?ad=share";

class Fail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      share: [
        {
          title: "Line",
          url: `https://line.me/R/share?text=${encodeURIComponent(
            invitation_text + " " + HTTP_REQUEST_URL,
          )}`,
          isClick: false,
        },
        {
          title: "WhatsApp",
          url: `https://api.whatsapp.com/send?text=${encodeURIComponent(
            `${invitation_text} ${HTTP_REQUEST_URL}`,
          )}`,
          isClick: false,
        },
        {
          title: "Sms",
          url: `sms:${
            MobileDetectUtil.judgeClient() === "iOS" ? "" : "//"
          }?&body=${encodeURIComponent(
            invitation_text + " " + HTTP_REQUEST_URL,
          )}`,
          isClick: false,
        },
        {
          title: "Telegram",
          url: `${
            MobileDetectUtil.judgeClient() === "iOS"
              ? "tg://msg?text"
              : "https://t.me/share/url?url"
          }=${encodeURIComponent(
            invitation_text + " " + HTTP_REQUEST_URL,
          )}&ios_redirect=false`,
          isClick: false,
        },
        {
          title: "Twitter",
          url: `https://twitter.com/intent/tweet?lang=en&text=${invitation_text}&url=${encodeURIComponent(
            HTTP_REQUEST_URL,
          )}`,
          isClick: false,
        },
        {
          title: "Facebook",
          url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
            HTTP_REQUEST_URL,
          )}`,
          isClick: false,
        },
        // ✅ 新增 Messenger 分享
        {
          title: "Messenger",
          url: `${
            MobileDetectUtil.judgeClient() === "iOS"
              ? "fb-messenger://share/?link=" +
                encodeURIComponent(HTTP_REQUEST_URL)
              : "https://www.messenger.com/"
          }`,
          isClick: false,
        },
      ],
      shareClickNum: null || JSON.parse(localStorage.getItem("shareClickNum")),
      show: false,
    };

    this.routeHome = this.routeHome.bind(this);
    this.clivkToShare = this.clivkToShare.bind(this);
    this.closeShareMask = this.closeShareMask.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // if (localStorage.getItem("shareClickNum")) {
    //   let shareClickNum = JSON.parse(localStorage.getItem("shareClickNum"));
    //   this.setState({
    //     shareClickNum: parseInt(shareClickNum),
    //   });
    // }
  }

  routeHome() {
    let { history, location } = this.props;
    const search = location.search;
    history &&
      history.push({
        pathname: "/",
        search: location.search,
      });
  }

  clivkToShare(index) {
    let ad = JSON.parse(localStorage.getItem("ad"));
    CountPixelEventAPI.countPixelEvent(
      BASE_URL.replace("https://", ""),
      ad,
      "ClickTheShareButton",
    ).then((res) => {
      console.log(res);
    });
    let { share, shareClickNum } = this.state;
    if (shareClickNum === 2) {
      window.open(share[index].url, "_blank");
      setTimeout(() => {
        this.setState({ show: true }, () => {
          shareClickNum = parseInt(shareClickNum) + 1;
          this.setState({ shareClickNum: parseInt(shareClickNum) });
        });
      }, 1000);
      localStorage.setItem("shareClickNum", JSON.stringify(shareClickNum));
      return;
    }
    if (shareClickNum === 4) {
      window.open(share[index].url, "_blank");
      setTimeout(() => {
        this.setState({ show: true }, () => {
          shareClickNum = parseInt(shareClickNum) + 1;
          this.setState({ shareClickNum: parseInt(shareClickNum) });
        });
      }, 1000);
      localStorage.setItem("shareClickNum", JSON.stringify(shareClickNum));
      return;
    }
    window.open(share[index].url, "_blank");
    console.log(shareClickNum);
    if (shareClickNum === null) {
      shareClickNum = 1;
    } else {
      shareClickNum = parseInt(shareClickNum) + 1;
    }

    localStorage.setItem("shareClickNum", JSON.stringify(shareClickNum));
    setTimeout(() => {
      this.setState({ shareClickNum: parseInt(shareClickNum) }, () => {
        if (this.state.shareClickNum >= 7) {
          window.open(share[index].url, "_blank");
          setTimeout(() => {
            this.setState({ show: true });
          }, 1000);
        }
      });
    }, 1000);
  }

  closeShareMask() {
    this.setState({ show: !this.state.show });
  }

  render() {
    const { shareClickNum, show } = this.state;
    return (
      <React.Fragment>
        <HeadBar {...this.props} />
        <div className={`share-mask ${show ? "show" : ""}`}>
          <img
            src={shareClickNum >= 7 ? sahua : ""}
            alt=""
            className="sahua "
          />
          <div className="share-textBox">
            <Close
              size={25}
              color="#6ebc2a;"
              className="close-icon"
              onClick={this.closeShareMask}
            />
            <div className="lihua-icon">
              {shareClickNum >= 7 ? <Lihua size={100} /> : ""}
            </div>
            <div className="title">
              {shareClickNum >= 7 ? "Deel je succes!" : ""}
            </div>
            <div className="desc">
              {shareClickNum === 3
                ? "Stuur het naar een andere vriend. Delen met dezelfde vriend telt niet mee."
                : ""}
              {shareClickNum === 5
                ? "Je kunt het ook in groepschats delen."
                : ""}
              {shareClickNum >= 7
                ? "Bedankt voor je aanbeveling! Bestellingen worden met voorrang verwerkt!"
                : ""}
            </div>
          </div>
        </div>
        <div className="fail-page">
          <div className="head-bg">
            <img src={share} alt="" />
          </div>
          <p className="tip">{lang.failTitle}</p>
          <p>{lang.shareTip}</p>
          <div className="icon-row">
            {/* <div className="li-icon" onClick={() => this.clivkToShare(0)}>
              <img src={Line} alt="" />
            </div> */}
            <div className="icon li-icon">
              <Call
                size={20}
                className="li-icon"
                onClick={() => this.clivkToShare(1)}
              />
            </div>
            <Message
              size={40}
              className="li-icon"
              onClick={() => this.clivkToShare(2)}
            />
            <div className="icon li-icon" onClick={() => this.clivkToShare(6)}>
              <img src={Messenger} alt="" />
            </div>
            {/* <Telegram
              size={70}
              className="li-icon"
              onClick={() => this.clivkToShare(3)}
            />
            <Twtter
              size={70}
              className="li-icon"
              onClick={() => this.clivkToShare(4)}
            />
            <Facebook
              size={70}
              className="li-icon"
              onClick={() => this.clivkToShare(5)}
            /> */}
          </div>
          {shareClickNum !== null ? (
            <div className="loading-line">
              <div
                className={`bgc-line 
                ${shareClickNum === 1 && "w20"} 
                ${shareClickNum === 2 && "w40"}
                ${shareClickNum === 3 && "w40"} 
                ${shareClickNum === 4 && "w60"} 
                ${shareClickNum === 5 && "w60"} 
                ${shareClickNum === 6 && "w80"} 
                ${shareClickNum >= 7 && "w100"}`}
              >
                {shareClickNum === 1 && "20%"}
                {shareClickNum === 2 && "40%"}
                {shareClickNum === 3 && "40%"}
                {shareClickNum === 4 && "60%"}
                {shareClickNum === 5 && "60%"}
                {shareClickNum === 6 && "80%"}
                {shareClickNum >= 7 && "100%"}
              </div>
            </div>
          ) : (
            ""
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default Fail;
